export { default } from './SWSectionSearchBar';
